import React, { useRef, useState } from "react";
import "./IdCard.css";
import logoStaffing from "./../../images/logo.png";
import userAvatar from "./../../images/user.png";
import { connect } from "react-redux";
import constants from "../../constants";
import { capitalizeFirstLetter } from "../../services/StringOperation";
import { printSkeleton } from "../../services/GlobalSkeleton";
import { Skeleton } from "@mui/material";
import { Tooltip } from "@mui/material";

const IdCard = (props) => {
  const fileInputRef = useRef(null);

  const [photo, setPhoto] = useState("/user.png"); // default image
  const [name] = useState("John Doe");
  const [company] = useState("Staffing Connect");
  const [joiningDate] = useState("12-Jan-2024");
  const [jobSector] = useState("IT Sector");

  return (
    <div className="job-bx submit-resume" id="scrollFocusElement">
      <div className="job-bx-title clearfix">
        <h5 className="font-weight-700 pull-left text-uppercase">
          Identity Card
        </h5>
      </div>

      <div className="row">
        <center>
          <div className="id-card border border-grey">
            {/* LEFT */}
            <div className="left-card-side">
              <div
                className="photo"
                //   onClick={openFileChooser}
                title="Change Photo"
              >
                <img
                  src={
                    props.userInfo?.users_identity_card_photo
                      ? constants.API_BASE_URL +
                        props.userInfo?.users_identity_card_photo
                      : userAvatar
                  }
                  alt="Profile"
                />
              </div>

              {/* <input
                type="file"
                ref={fileInputRef}
                accept="image/png, image/jpeg, image/jpg"
                style={{ display: "none" }}
                onChange={handleImageChange}
              /> */}
            </div>

            {/* RIGHT */}
            <div className="right-card-side">
              <div className="logo-box">
                <img src={logoStaffing} alt="Company Logo" />
              </div>

              <div className="company text-left">{company}</div>
              <div className="name text-left">
                {props.userInfo?.users_firstname ? (
                  props.userInfo?.users_firstname +
                  " " +
                  props.userInfo?.users_lastname
                ) : (
                  <Skeleton
                    style={{
                      borderRadius: "10px",
                      backgroundColor: "#e6d5ff",
                    }}
                    variant={"rounded"}
                    className={"bg-default mb-2"}
                    width={"100%"}
                    height={30}
                  />
                )}
              </div>

              <div className="info text-left">
                {props.userInfo?.users_created_date ? (
                  <div className="cursor-pointer">
                    <Tooltip
                      title="Date of Joining"
                      className="text-sm"
                      placement={"top"}
                      arrow={true}
                    >
                      <b>
                        <i
                          className="fa fa-calendar mr-1"
                          style={{ color: "#6610f2" }}
                        ></i>
                      </b>{" "}
                      {props.userInfo?.users_created_date
                        ? props.userInfo?.users_created_date
                        : ""}
                    </Tooltip>
                  </div>
                ) : (
                  <Skeleton
                    style={{
                      borderRadius: "10px",
                      backgroundColor: "#e6d5ff",
                    }}
                    variant={"rounded"}
                    className={"bg-default mb-2"}
                    width={"50%"}
                    height={20}
                  />
                )}

                {props.userInfo?.users_category ? (
                  <div className="cursor-pointer">
                    <Tooltip
                      title="Job Sector"
                      className="text-sm"
                      placement={"top"}
                      arrow={true}
                    >
                      <b>
                        <i
                          className="fa fa-briefcase mr-1"
                          style={{ color: "#6610f2" }}
                        ></i>
                      </b>{" "}
                      {props.userInfo?.users_category
                        ? capitalizeFirstLetter(
                            String(props.userInfo?.users_category)
                          )
                        : ""}
                    </Tooltip>
                  </div>
                ) : (
                  <Skeleton
                    style={{
                      borderRadius: "10px",
                      backgroundColor: "#e6d5ff",
                    }}
                    variant={"rounded"}
                    className={"bg-default mb-2"}
                    width={"50%"}
                    height={20}
                  />
                )}
              </div>
            </div>

            {/* FOOTER */}
            <div className="foter_new">
              <center>
                <a
                  href="https://www.staffingconnect.co.uk/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-white text-center"
                >
                  <i className="fa fa-globe mr-1"></i> www.staffingconnect.co.uk
                </a>
              </center>
            </div>
          </div>
        </center>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userAuth: state.auth.authUserData,
    userInfo: state.userProfile.userData,
  };
};
export default connect(mapStateToProps)(IdCard);
